import React from 'react';
import PropTypes from 'prop-types';

const UserResultItem = props => {
  const selectedStyle = {
    backgroundColor: props.color,
    borderColor: props.color,
    color: '#FFF',
  };
  const finalStyle =
    props.hoverSelectedUserIndex === props.index ? selectedStyle : null;

  return (
    <li // eslint-disable-line
      className="user-result-item"
      id={`user-result-item-${props.index}`}
      style={finalStyle}
      onClick={event =>
        props.userResultClick(
          props.user.fullName,
          props.user.emailAddress,
          props.user.department,
          props.user.employeeId,
          event,
        )
      }
      onMouseEnter={() => props.changeHoverSelectedUser(props.index)}
    >
      <span>{props.user.fullName}</span>
      <span>{props.user.department}</span>
      <span>{props.user.emailAddress}</span>
    </li>
  );
};

UserResultItem.propTypes = {
  user: PropTypes.shape({
    fullName: PropTypes.string,
    emailAddress: PropTypes.string,
    department: PropTypes.string,
    employeeId: PropTypes.string,
  }).isRequired,
  color: PropTypes.string.isRequired,
  userResultClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
  hoverSelectedUserIndex: PropTypes.number.isRequired,
  changeHoverSelectedUser: PropTypes.func.isRequired,
};

export default UserResultItem;
